import React from "react";
import { useObservable, useObserver, observer } from "mobx-react-lite";
import _ from "lodash";
import { Pane, TextInput, Button } from "evergreen-ui";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import { Text, Enum, Formula, Number, Relation, NumberAPI } from "./types";

const fieldTypes = {
  text: Text,
  number: Number,
  enum: Enum,
  relation: Relation,
  formula: Formula,
  numberAPI: NumberAPI
};

const UPDATE_TYPE = gql`
  mutation UpdateType($id: String!, $data: String!) {
    updateType(data: $data, id: $id)
  }
`;

export default ({ type, types }) => {
  const activeType = useObservable(JSON.parse(type.data));
  const [updateType] = useMutation(UPDATE_TYPE);
  const modifyType = field => e => {
    const value = e.target ? e.target.value : e;
    _.set(activeType, field, value);
  };
  const addField = type => () => {
    activeType.fields.push({
      name: "",
      type
    });
  };
  return useObserver(() => (
    <Pane>
      <Link to="/types">wróć</Link>
      <TextInput
        placeholder="Type name"
        value={activeType.name}
        onChange={modifyType("name")}
      />
      <TextInput
        placeholder="Type parent"
        value={activeType.parent}
        onChange={modifyType("parent")}
      />
      <TextInput
        placeholder="Type parent field"
        value={activeType.parentField}
        onChange={modifyType("parentField")}
      />
      <TextInput
        placeholder="Type auth"
        value={activeType.auth}
        onChange={modifyType("auth")}
      />
      {activeType.fields &&
        activeType.fields.map((field, key) => {
          const TypeComponent = observer(fieldTypes[field.type]);
          return (
            <Pane key={key}>
              Typ pola: <b>{field.type}</b>
              <br />
              Nazwa pola:
              <TextInput
                placeholder="FIeld name"
                value={field.name}
                onChange={e => (field.name = e.target.value)}
              />
              <br />
              Czy zmiany pola mają być śledzone?
              <input
                type="checkbox"
                checked={field.tracked}
                onChange={() => (field.tracked = !field.tracked)}
              />
              <br />
              <TypeComponent types={types} field={field} />
              <br />
              <hr />
              <br />
            </Pane>
          );
        })}
      <Pane onClick={addField("text")}>New text field</Pane>
      <Pane onClick={addField("number")}>New number</Pane>
      <Pane onClick={addField("enum")}>New enum</Pane>
      <Pane onClick={addField("relation")}>New relation</Pane>
      <Pane onClick={addField("formula")}>New formula</Pane>
      <Pane onClick={addField("numberAPI")}>New numberAPI</Pane>
      <Button
        onClick={() =>
          updateType({
            variables: { id: type._id, data: JSON.stringify(activeType) },
            refetchQueries: ["Types"]
          })
        }
      >
        Save
      </Button>
    </Pane>
  ));
};
